<template>
  <v-app id="good3">
    <v-navigation-drawer id="good3_drawer"
      v-model="drawer"
      clipped
      fixed
      app
    >
      <v-list class="transparent" dense>
        <v-list-item to="/profiles" active-class="yellow--text" class="body-2 my-3">
          <v-list-item-action>
            <v-icon size="30">account_box</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="body-2">
              Profiles
              <div class="good3-chipsMenuItem">
                {{ armoryProfiles === null ? 0 : armoryProfiles.length }}
              </div>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item to="/heroes" active-class="yellow--text" class="body-2 my-3">
          <v-list-item-action>
            <v-icon size="30">group</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="body-2">
              Heroes
              <div class="good3-chipsMenuItem">
                12k
              </div>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item to="/items" active-class="yellow--text" class="body-2 my-3">
          <v-list-item-action>
            <v-icon size="30">settings</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="body-2">
              Items
              <div class="good3-chipsMenuItem">
                2.3m
              </div>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      app
      fixed
      clipped-left
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-btn
        icon
        class="mx-2"
        :to="{ name: 'Dashboard', params: {}}"
      >
        <v-icon>mdi-home</v-icon>
      </v-btn>
      <v-toolbar-title class="mx-2">
        Armurerie
      </v-toolbar-title>
      <v-spacer></v-spacer>

      <v-menu
        transition="slide-y-transition"
        offset-y
        nudge-bottom="15"
      >
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            class="mx-2"
            v-on="on"
          >
            <v-icon>mdi-account-circle</v-icon>
          </v-btn>
        </template>
        <v-list id="good3_toolbarMenu">
          <v-list-item>
            <v-list-item-avatar>
              <v-icon>mdi-account-circle</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>{{ currentUser.first_name }} {{ currentUser.last_name }}</v-list-item-title>
              <v-list-item-subtitle>#{{ currentUser.username }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="doLogout">
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <v-content id="good3_content" :style="backgroundImageStyle">
      <router-view></router-view>
    </v-content>

    <v-footer app fixed class="px-3">
      <span>2019 &dash; Atrilogie</span>
    </v-footer>
  </v-app>
</template>

<script>
import axios from 'axios'

// MIXINS
import { Good3Lib } from '../good3lib/good3_lib'

// VUEX
import { mapGetters } from 'vuex'

// DEFAULT
export default {
  name: 'GOOD3_MAIN_WINDOW',

  // Importing VUEJS shared resources
  //
  // • props for input
  // • components for sub vue components
  // • mixins for methods libraries
  props: {},
  components: {},
  mixins: [Good3Lib],

  // Accessible properties
  //
  // • data
  // • computed
  // • watch
  data: () => ({
    drawer: true,
    backgroundImageStyle: {
      'background-image': 'url(' + require('../assets/wall_old_tristram.jpg') + ')',
      // 'background-image': 'url(' + require('../assets/wall_sea.jpg') + ')',
      'background-size': 'cover',
      'background-position': 'center center',
      'background-repeat': 'no-repeat',
      'background-color': 'grey darken-3',
      'background-attachment': 'fixed'
    }
  }),
  computed: {
    // FROM VUEX
    ...mapGetters([
      'isUserLoggedIn',
      'currentUser',
      'armoryProfiles'
    ])
  },
  watch: {},

  // VUEJS lifecycle hooks
  //
  // • created
  // • mounted

  // Components methods
  methods: {
    // doLogout logs the user out by calling the backend (to remove the secure
    // login cookie) and also by removing the user information from the store.
    doLogout () {
      // calling the backend to remove the login cookie
      axios.get(this.helpMeBackendURLForPath('good3?action=logout'))
        .then(response => {
          // we don't actually care about the response :)
        })
        .catch(error => {
          console.log(error)
        })

      // removing the local store data belonging to the user
      this.$store.commit('fullReset')
    }
  }
}
</script>

<style scoped>
#good3_content {
  height: 100%;
  width: 100%;
  background-color: #424242a0;
}

#good3_drawer {
  height: 100%;
  width: 100%;
  background-color: #424242d0;
}

#good3_toolbarMenu {
  background-color: #424242a0;
}

</style>
